import type { TButtonField } from "@shared/types/form";
import { useFormContext } from ".";
import { Button } from "@shared/ui/button";
import { Loader2 } from "lucide-react";

export function SubmitButton({
	isLoading = false,
	loadingTitle = "",
	title,
	...props
}: TButtonField) {
	const form = useFormContext();
	return (
		<form.Subscribe selector={(state) => state.isSubmitting}>
			{(isSubmitting) => (
				<Button
					type="button"
					onClick={() => form.handleSubmit()}
					disabled={isSubmitting || isLoading}
					{...props}
				>
					{isSubmitting || (isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" />)}
					{isSubmitting || isLoading ? loadingTitle : title}
				</Button>
			)}
		</form.Subscribe>
	);
}
